import React from 'react';
import { TextInput } from 'components/Input';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

export default (props: Props) => {
  const { value, onChange } = props;
  return (
    <TextInput
      id="table-editable-text"
      value={value}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
      width="100%"
      height="26px"
      fontSize="12"
      fullWidth
      noBorder
    />
  );
};
